<template>
   <div id="layoutDefault">
            <div id="layoutDefault_content">
                <main>
                    <MainNav />
                    <header class="page-header page-header-dark bg-gradient-primary-to-secondary">
                        <div class="page-header-content pt-10">
                            <div class="container">
                                <div class="row align-items-center">
                                    <div class="col-lg-6" data-aos="fade-up">
                                        <h1 class="page-header-title">We can Outsmart IBD!</h1>
                                        <h1 class="page-header-title">We are Better Together!</h1>
                                        <p class="page-header-text mb-5 lead">Receiving a diagnosis of Crohn’s disease or ulcerative colitis can feel scary 
                                            and overwhelming – it’s a club no one wants to join. <span class="text-mid-75">You are not alone.</span> There are many patients 
                                            with IBD and family members from the ImproveCareNow&trade; Community who know exactly how you feel. They want to 
                                            help by sharing the information and resources they found most useful right after they were diagnosed.</p>
                                        <form>
                                            <div class="input-group mb-3">
                                                <input type="email" v-model="form.email" id="email" class="form-control" placeholder="Email" aria-label="Email" aria-describedby="button-addon2" onclick="dataLayer.push({'event': 'home-add-email-input'});">
                                                <div class="input-group-append">
                                                    <button v-on:click="submitForm" class="btn btn-success" type="button" id="joinNewsLetter" onclick="dataLayer.push({'event': 'join-newsletter-clicked'});">Join our Newsletter</button>
                                                </div>
                                                <p><small class="font-weight-light disclaimer">Enter your email to join our CIRCLE! We'll email you every other week 
                                                    with useful IBD resources, stories about life IBD, and ImproveCareNow&trade; updates &amp; opportunities.</small></p>
                                            </div>
                                        </form>
                                        <div class="powr-mailing-list" id="71ba9a82_1608154362"></div>
                                    </div>
                                    <div class="col-lg-6 d-none d-lg-block" data-aos="fade-up" data-aos-delay="50"><img class="img-fluid" src="../assets/new_parents.png" /></div>
                                </div>
                            </div>
                        </div>
                        <div class="svg-border-rounded text-white">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </header>
                    <section class="bg-white py-10">
                        <div class="container">
                            <div class="row">
                               <div class="col-lg-6 mb-lg-n10 mb-5 mb-lg-0 z-1">
                                    <router-link class="card text-decoration-none h-100 lift" to="/resource-list" onclick="dataLayer.push({'event': 'home-resource-box'});"
                                        ><div class="card-body py-5">
                                            <div class="d-flex align-items-center">
                                                <div class="icon-stack icon-stack-xl bg-primary text-white flex-shrink-0"><i class="fas fa-book-open"></i></div>
                                                <div class="ml-4">
                                                    <h5 class="text-primary">Resources</h5>
                                                    <p class="card-text text-gray-600">We can Outsmart IBD!  Access a curated collection of resources &amp; information that ICN patients and families found useful as they adjusted to life with IBD <i class="fas fa-heart text-primary"></i></p>
                                                </div>
                                            </div>
                                        </div></router-link
                                    >
                                </div>
                                <div class="col-lg-6 mb-lg-n10 mb-5 mb-lg-0 z-1">
                                    <router-link class="card text-decoration-none h-100 lift" to="/support" onclick="dataLayer.push({'event': 'home-support-box'});"
                                        ><div class="card-body py-5">
                                            <div class="d-flex align-items-center">
                                                <div class="icon-stack icon-stack-xl bg-success text-white flex-shrink-0"><i class="fas fa-hands-helping"></i></div>
                                                <div class="ml-4">
                                                    <h5 class="text-success">Support</h5>
                                                    <p class="card-text text-gray-600">There’s a group for patients with IBD and a group for family and caregivers  <i class="fas fa-heart text-success"></i></p>
                                                </div>
                                            </div>
                                        </div></router-link
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="svg-border-rounded text-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </section>
                    <section class="bg-light py-10 hide">
                        <div class="container">
                            <div class="row align-items-center justify-content-center">
                                <div class="col-md-9 col-lg-6 order-1 order-lg-0" data-aos="fade-right">
                                    <div class="content-skewed content-skewed-right"><img class="content-skewed-item img-fluid shadow-lg rounded-lg" src="https://via.placeholder.com/450" /></div>
                                </div>
                                <div class="col-lg-6 order-0 order-lg-1 mb-5 mb-lg-0" data-aos="fade-left">
                                    <div class="mb-5">
                                        <h1>Latest Advancements</h1>
                                        <p class="lead">Excepteur sint occaecat cupidatat non proident sunt iculpa qui officia deserunt mollit anim est. laborum sed perspiciatis unde omnis natus error sit voluptatem accusantium dolore mque laudantium totam rem aperiam.
                                        Dicta sunt explicabo. nemo enim ipsam voluptatem quia magni voluptassit aspernatur aut odit aut fugit sed quia consequuntur magni dolores eos.</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 mb-4">
                                            <h6>Example Title</h6>
                                            <p class="mb-2 small">Etiam maximus, justo ut pellentesque egestas, erat sapien mollis massa, nec porta nisl quam eu arcu. Donec sit amet congue lectus</p>
                                            <a class="small text-arrow-icon" href="#!">Learn More<i data-feather="arrow-right"></i></a>
                                        </div>
                                        <div class="col-md-6 mb-4">
                                            <h6>Example Title</h6>
                                            <p class="mb-2 small mb-0">Etiam maximus, justo ut pellentesque egestas, erat sapien mollis massa, nec porta nisl quam eu arcu. Donec sit amet congue lectus</p>
                                            <a class="small text-arrow-icon" href="#!">Learn More<i data-feather="arrow-right"></i></a>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6 mb-4">
                                            <h6>Example Title</h6>
                                            <p class="mb-2 small mb-0">Etiam maximus, justo ut pellentesque egestas, erat sapien mollis massa, nec porta nisl quam eu arcu. Donec sit amet congue lectus</p>
                                            <a class="small text-arrow-icon" href="#!">Learn More<i data-feather="arrow-right"></i></a>
                                        </div>
                                        <div class="col-md-6 mb-4">
                                            <h6>Example Title</h6>
                                            <p class="small mb-0">Etiam maximus, justo ut pellentesque egestas, erat sapien mollis massa, nec porta nisl quam eu arcu. Donec sit amet congue lectus</p>
                                            <a class="small text-arrow-icon" href="#!">Learn More<i data-feather="arrow-right"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <!-- <hr class="m-0" /> -->
                    <section class="bg-light pt-10 hide">
                        <div class="container">
                            <div class="text-center mb-5">
                                <h1>What to expect in the first 3 months</h1>
                                <p class="lead">Etiam maximus, justo ut pellentesque egestas.</p>
                            </div>
                            <div class="row z-1">
                                <div class="col-lg-4 mb-5 mb-lg-n10" data-aos="fade-up" data-aos-delay="100">
                                    <div class="card pricing h-100">
                                        <div class="card-body p-5">
                                            <div class="text-center">
                                                <div class="badge badge-light badge-pill badge-marketing badge-sm">Month 1</div>
                                                <div class="pricing-price">Title</div>
                                            </div>
                                            <ul class="fa-ul pricing-list">
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span><span class="text-dark">List Item or Link</span>
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span><span class="text-dark">List Item or Link</span>
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-circle text-gray-200"></i></span>List Item or Link
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-circle text-gray-200"></i></span>List Item or Link
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-circle text-gray-200"></i></span>List Item or Link
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-circle text-gray-200"></i></span>List Item or Link
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-circle text-gray-200"></i></span>List Item or Link
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 mb-5 mb-lg-n10" data-aos="fade-up">
                                    <div class="card pricing h-100">
                                        <div class="card-body p-5">
                                            <div class="text-center">
                                                <div class="badge badge-light badge-pill badge-marketing badge-sm">Month 2</div>
                                                <div class="pricing-price">Title</div>
                                            </div>
                                            <ul class="fa-ul pricing-list">
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span><span class="text-dark">List Item or Link</span>
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span><span class="text-dark">List Item or Link</span>
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span><span class="text-dark">List Item or Link</span>
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span><span class="text-dark">List Item or Link</span>
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span><span class="text-dark">List Item or Link</span>
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span><span class="text-dark">List Item or Link</span>
                                                </li>
                                                <li class="pricing-list-item">
                                                    <span class="fa-li"><i class="far fa-check-circle text-teal"></i></span><span class="text-dark">List Item or Link</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 mb-lg-n10" data-aos="fade-up" data-aos-delay="100">
                                    <div class="card pricing h-100">
                                        <div class="card-body p-5">
                                            <div class="text-center">
                                                <div class="badge badge-light badge-pill badge-marketing badge-sm">Month 3</div>
                                                <div class="pricing-price">Title</div>
                                                <p class="card-text py-8">Etiam maximus, justo ut pellentesque egestas, erat sapien mollis massa, nec porta nisl quam eu arcu. Donec sit amet congue lectus</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="svg-border-rounded text-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </section>
                    <section class="bg-dark py-10">
                        <div class="container">
                            <div class="row my-10">
                                <div class="col-lg-12 mb-5">
                                    <div class="d-flex h-100">
                                        <div class="icon-stack flex-shrink-0 bg-primary text-white"><i class="fas fa-exclamation"></i></div>
                                        <div class="ml-4">
                                            <h1 class="text-white">What is ImproveCareNow&trade;?</h1>
                                            <h4 class="text-white-75">ImproveCareNow&trade; (ICN) is a Learning Health Network dedicated to transforming care, health and costs for all children and youth 
                                                with Crohn’s disease and ulcerative colitis (Inflammatory Bowel Disease or IBD) by building a sustainable collaborative chronic care network. ICN is 
                                                enabling and empowering patients, families, clinicians and researchers to work together in a learning health care system to accelerate innovation, discovery 
                                                and the application of new knowledge, and transform care and outcomes of children with IBD.</h4>
                                            <br/>
                                            <p><a href="https://www.improvecarenow.org/" target="_blank" onclick="dataLayer.push({'event': 'home-whatisICN-link'});">Visit ImproveCareNow&trade; <i class="fas fa-arrow-right"></i></a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="svg-border-rounded text-white"> 
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </section>
                    <section class="bg-white py-10">
                        <div class="container">
                            <div class="text-center mb-5">
                                <h1 class="text-primary">Get in the LOOP</h1>
                                <p class="lead text-success">with stories from the ICN Blog</p>
                            </div>
                            <div class="row mb-5">
                                <div class="col-lg-4 mb-5">
                                    <a class="card lift h-100" href="https://www.improvecarenow.org/living_with_ibd_is_definitely_a_struggle_but_it_really_does_make_me_a_stronger_person" target="_blank"><img class="card-img-top" src="https://d3n8a8pro7vhmx.cloudfront.net/improvecarenow/pages/5300/attachments/original/1618339737/Mira_Shrayer_Quote_Card.png?1618339737" alt="...">
                                        <div class="card-body">
                                            <h4 class="card-title mb-2">Living with IBD is definitely a struggle but it really does make me a stronger person.</h4>
                                            <p class="card-text">My name is Mira, I am a 15 year high school freshman. I was diagnosed with ulcerative colitis when I was 11. An interesting thing most people don’t know about me is...</p>
                                        </div>
                                        <div class="card-footer bg-transparent border-top d-flex align-items-center justify-content-between">
                                            <div class="small text-primary">Read More at ImproveCareNow</div>
                                            <div class="small text-primary"><i class="fas fa-external-link-alt"></i></div></div></a>                                
                                </div>
                                <div class="col-lg-4 mb-5">
                                    <a class="card lift h-100" href="https://www.improvecarenow.org/know_your_iron_status_iron_deficiency_and_ibd" target="_blank"><img class="card-img-top" src="https://d3n8a8pro7vhmx.cloudfront.net/improvecarenow/pages/5304/attachments/original/1618855897/Iron_Deficiency_-_LOOP_-_ICN_RD.png?1618855897" alt="...">
                                        <div class="card-body">
                                            <h4 class="card-title mb-2">Know your iron status: Iron deficiency and IBD</h4>
                                            <p class="card-text">Anemia is common in IBD and iron deficiency is the leading cause. Studies show up to 95% of individuals newly diagnosed with IBD are iron deficient. Learn more about iron deficiency...</p>
                                        </div>
                                        <div class="card-footer bg-transparent border-top d-flex align-items-center justify-content-between">
                                            <div class="small text-primary">Read More at ImproveCareNow</div>
                                            <div class="small text-primary"><i class="fas fa-external-link-alt"></i></div></div></a>
                                </div>
                                <div class="col-lg-4 mb-5">
                                    <a class="card lift h-100" href="https://www.improvecarenow.org/an_issue_may_seem_like_an_insurmountable_mountain_but_there_is_always_the_other_side" target="_blank"><img class="card-img-top" src="https://d3n8a8pro7vhmx.cloudfront.net/improvecarenow/pages/5296/attachments/original/1617926999/Henry_Brittain_Quote_Card.png?1617926999" alt="...">
                                        <div class="card-body">
                                            <h4 class="card-title mb-2">An issue may seem like an insurmountable mountain, but there is always the other side.</h4>
                                            <p class="card-text">Hello! My name is Henry, and I am a 14 year old freshman in high school. I was diagnosed...</p>
                                        </div>
                                        <div class="card-footer bg-transparent border-top d-flex align-items-center justify-content-between">
                                            <div class="small text-primary">Read More at ImproveCareNow</div>
                                            <div class="small text-primary"><i class="fas fa-external-link-alt"></i></div></div></a>                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="bg-white py-10">
                        <div class="container mt-5">
                            <div class="row align-items-center">
                                <div class="col-lg-12">
                                    <h2 class="text-center mb-5">Find the closest Care Center</h2>
                                    <iframe src="https://www.powr.io/map/u/b1925973_1608126563#platform=iframe" style="width:100%;" height="464px" frameborder="0" onclick="dataLayer.push({'event': 'home-map-section'});"></iframe>
                                </div>
                            </div>
                        </div>
                    </section>
                    <hr class="m-0" />
                    <!-- <section class="bg-white py-10">
                        <div class="container mt-5">
                            <div class="row align-items-center">
                                <div class="col-lg-6">
                                    <h4>Ready to join our Community?</h4>
                                    <p class="lead mb-5 mb-lg-0 text-gray-500">Create your account today.</p>
                                </div>
                                <div class="col-lg-6 text-lg-right"><a class="btn btn-white btn-marketing rounded-pill my-2 lift lift-sm" href="#!">Create Account</a></div>
                            </div>
                        </div>
                    </section>
                    <hr class="m-0" /> -->
                </main>
            </div>
            <div id="layoutDefault_footer">
                <MainFooter />
            </div>
        </div>
</template>

    
<script>
import $ from 'jquery';
import axios from 'axios'
import VueAxios from 'vue-axios'
import MainNav from '@/components/nav.vue'
import MainFooter from '@/components/footer.vue'

export default {
  name: 'Home',
  components: {
    MainNav,
    MainFooter
  },
    data(){
        return{
            form: {
                email: ''
            }
        }
    },
    methods:{
        submitForm(){
            let apiCallOneURL = process.env.VUE_APP_API + '/api/newsemail/myICNhome/newsLetter/' + this.form.email;
            let apiCallTwoURL = process.env.VUE_APP_API_CLIENT_URL + '?access-token=' + process.env.VUE_APP_API_CLIENT_TOKEN;

            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin' : '*',
                }
            };

            var postData = {
                email: this.form.email,
                tags: process.env.VUE_APP_API_CLIENT_TAG
            };

            const requestOne = axios.post(apiCallOneURL);
            const requestTwo = axios.put(apiCallTwoURL, postData, axiosConfig);
            $('#email').val('');
            $('#joinNewsLetter').html('Thank you for Registering!');

            axios
            .all([requestOne, requestTwo])
            .then(
                axios.spread((...responses) => {
                const responseOne = responses[0];
                const responseTwo = responses[1];

                // use/access the results
                console.log(responseOne, responseTwo);
                })
            )
            .catch(errors => {
                // react on errors.
                console.error(errors);
            });
           
        }
    }
}

// Collapse Navbar
// Add styling fallback for when a transparent background .navbar-marketing is scrolled
var navbarCollapse = function() {
    if($(".navbar-marketing.bg-transparent.fixed-top").length === 0) {
        return;
    }
    if ($(".navbar-marketing.bg-transparent.fixed-top").offset().top > 0) {
        $(".navbar-marketing").addClass("navbar-scrolled");
    } else {
        $(".navbar-marketing").removeClass("navbar-scrolled");
    }
};
// Collapse now if page is not at top
navbarCollapse();
// Collapse the navbar when page is scrolled
$(window).scroll(navbarCollapse);

</script>